import React from 'react'
import FileBdItem from './FileBdItem'

const FileBdList = ({ type, files }) => {
  return (
    <div className='fileListBlock__list fileUploadedList'>
        {
            files && files.length > 0 ?
                files.map(file => {
                    if (file.type == type) {
                        return (
                            <FileBdItem 
                                key={file.fileName}
                                file={file}
                            />
                        )
                    }
                })
            : ''
        }
    </div>
  )
}

export default FileBdList